import React, { useState, useEffect } from 'react'
import { getProducts } from "../products"
import { Product } from "../components/Product"
import { List, X } from 'phosphor-react'
import SEOHead from '../components/SEOHead'
import Breadcrumbs from '../components/Breadcrumbs'
import "./Shop.css"

const Shop = ({ search = "", categoryFilter = "", onClearFilter }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState(categoryFilter);
  const [showMobileFilters, setShowMobileFilters] = useState(false);

  const categories = [
    { id: '', name: 'Todos os produtos' },
    { id: 'Videovigilância', name: 'Videovigilância' },
    { id: 'Alarmes', name: 'Alarmes' },
    { id: 'Videoporteiros', name: 'Videoporteiros' },
    { id: 'Acessórios', name: 'Acessórios' }
  ];

  useEffect(() => {
    const loadProducts = async () => {
      setLoading(true);
      try {
        const productsData = await getProducts();
        setProducts(productsData);
      } catch (error) {
        console.error('Erro ao carregar produtos:', error);
      } finally {
        setLoading(false);
      }
    };

    loadProducts();
  }, []);

  useEffect(() => {
    setSelectedCategory(categoryFilter);
  }, [categoryFilter]);

  const filteredProducts = products.filter(product => {
    const matchesSearch = product.name.toLowerCase().includes(search.toLowerCase());
    const matchesCategory = !selectedCategory || product.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  const handleCategorySelect = (categoryId) => {
    setSelectedCategory(categoryId);
    setShowMobileFilters(false);
    // Se existe a função onClearFilter, significa que o filtro veio do navbar
    if (categoryId === '' && onClearFilter) {
      onClearFilter();
    }
  };

  if (loading) {
    return (
      <section className="produtos-section">
        <div className="wellcome">
          <h1>Produtos</h1>
        </div>
        <div className="loading">
          <p>Carregando produtos...</p>
        </div>
      </section>
    );
  }

  return (
    <section className="produtos-section">
      <SEOHead
        title="Loja de Equipamentos de Segurança | MercadoTV"
        description="Explore nossa loja completa de equipamentos de segurança: câmaras de videovigilância, alarmes Ajax, videoporteiros e acessórios. Preços competitivos e instalação profissional."
        keywords="loja segurança portugal, câmaras vigilância, alarmes ajax preço, videoporteiros, equipamentos segurança, cctv loja online, sistemas alarme, videovigilância preços"
        canonicalUrl="https://mercadotv.pt/shop"
      />
      
      <Breadcrumbs />
      
      <div className="wellcome">
        <h1>Produtos</h1>
        <p>Descubra a nossa gama completa de produtos de segurança</p>
        {(categoryFilter || selectedCategory) && (
          <div className="category-filter-indicator">
            <span>Filtrado por: <strong>{selectedCategory || categoryFilter}</strong></span>
            <button 
              className="clear-filter-btn"
              onClick={() => handleCategorySelect('')}
            >
              ✕ Limpar filtro
            </button>
          </div>
        )}
      </div>

      <div className="shop-layout">
        {/* Filtros laterais - Desktop */}
        <aside className="filters-sidebar">
          <div className="filters-header">
            <h3>Filtros</h3>
          </div>
          <div className="filter-group">
            <h4>Categorias</h4>
            <div className="category-filters">
              {categories.map(category => (
                <button
                  key={category.id}
                  className={`filter-btn ${selectedCategory === category.id ? 'active' : ''}`}
                  onClick={() => handleCategorySelect(category.id)}
                >
                  {category.name}
                </button>
              ))}
            </div>
          </div>
        </aside>

        {/* Botão de filtros mobile */}
        <div className="mobile-filters-toggle">
          <button 
            className="mobile-filter-btn"
            onClick={() => setShowMobileFilters(true)}
          >
            <List size={20} />
            Filtros
          </button>
        </div>

        {/* Overlay de filtros mobile */}
        {showMobileFilters && (
          <div className="mobile-filters-overlay">
            <div className="mobile-filters-content">
              <div className="mobile-filters-header">
                <h3>Filtros</h3>
                <button 
                  className="close-mobile-filters"
                  onClick={() => setShowMobileFilters(false)}
                >
                  <X size={24} />
                </button>
              </div>
              <div className="filter-group">
                <h4>Categorias</h4>
                <div className="category-filters">
                  {categories.map(category => (
                    <button
                      key={category.id}
                      className={`filter-btn ${selectedCategory === category.id ? 'active' : ''}`}
                      onClick={() => handleCategorySelect(category.id)}
                    >
                      {category.name}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Área principal de produtos */}
        <main className="produtos-main">
          <div className="produtos-header">
            <span className="produtos-count">
              {filteredProducts.length} produto{filteredProducts.length !== 1 ? 's' : ''} encontrado{filteredProducts.length !== 1 ? 's' : ''}
            </span>
          </div>
          <div className="produtos-container">
            {filteredProducts.length > 0 ? (
              filteredProducts.map((product) => (
                <Product key={product.id} data={product} />
              ))
            ) : (
              <div className="no-products">
                <p>{search ? "Nenhum produto encontrado para a pesquisa." : "Nenhum produto disponível."}</p>
              </div>
            )}
          </div>
        </main>
      </div>
    </section>
  )
}

export default Shop;
